import { MeasurementAggregators } from "@validereinc/domain";
import { convertMapToOpts } from "../shared/index.ts";
import { toTitleCaseString } from "@validereinc/utilities";

export const MeasurementAggregatorOptions = convertMapToOpts(
  MeasurementAggregators,
  ([_, value]) => toTitleCaseString(value)
);

export const PollutantsEmitted = {
  co2_eq: {
    id: "co2_eq",
    label: "CO2e",
    mass: "mass_co2eq",
  },
  co2: {
    id: "co2",
    label: "CO2",
    mass: "mass_co2",
  },
  ch4: {
    id: "c1",
    label: "CH4",
    mass: "mass_ch4",
  },
  n2o: {
    id: "n2o",
    label: "N2O",
    mass: "mass_n2o",
  },
} as const;
export const PollutantsEmittedOptions = Object.values(PollutantsEmitted).map(
  (p) => {
    return {
      label: p.label,
      value: p.id,
    };
  }
);
